import SanityImageUrl from '@sanity/image-url'

import { sanityConfig } from '@/lib/config.shared'

import type { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder'
import type { SanityImageSource } from '@sanity/image-url/lib/types/types'

const imageUrlBuilder = SanityImageUrl({
  projectId: sanityConfig.projectId,
  dataset: sanityConfig.dataset,
})

const hasResolvableAsset = (image: ImageUrlBuilder) => {
  try {
    image.url()

    return true
  } catch {
    return false
  }
}

export const resolveSanityImage = (source: SanityImageSource | null | undefined): ImageUrlBuilder | undefined => {
  if (source == null) {
    return undefined
  }

  const image = imageUrlBuilder.image(source)

  return hasResolvableAsset(image) ? image : undefined
}
